export function generateProjectLabel(name = '', code = ''): string {
  if (!code) {
    return name;
  } else {
    return `${name} (${code})`;
  }
}
